// Kenyan shillings with two decimals and thousands separators; negatives in brackets for reports.
export const kes = (v) => Number(v || 0).toLocaleString("en-KE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const acct = (v) => (Number(v || 0) < 0 ? `(${kes(-v)})` : kes(v));
export const today = () => new Date().toISOString().slice(0, 10);
export const fmtDate = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");
export const TYPE_LABELS = { asset: "Asset", liability: "Liability", equity: "Equity", income: "Income", expense: "Expense" };
export const SUBTYPE_LABELS = {
  cash_bank: "Cash & bank", receivable: "Receivable", stock: "Stock", tax: "Tax", supplier_account: "Supplier account",
  other_current: "Other current", fixed_asset: "Fixed asset", deposit: "Deposit", payable: "Payable", long_term: "Long-term",
  capital: "Capital", retained_earnings: "Retained earnings", drawings: "Drawings", sales: "Sales", other_income: "Other income",
  cost_of_sales: "Cost of sales", operating: "Operating expense", other_expense: "Other expense",
};
export const SUBTYPES = {
  asset: ["cash_bank", "receivable", "stock", "tax", "supplier_account", "other_current", "fixed_asset", "deposit"],
  liability: ["payable", "tax", "other_current", "long_term"],
  equity: ["capital", "retained_earnings", "drawings"],
  income: ["sales", "other_income"],
  expense: ["cost_of_sales", "operating", "other_expense"],
};
